var module = angular.module('octopusApp.projects');

module.controller('VariableValueEditorModalController', function ($scope, $uibModalInstance, variable, variableTypes, $location) {
    var vm = this;

    vm.variable = variable;
    vm.variableTypes = variableTypes.all();

    vm.editor = null;
    vm.syntax = 'text'; //"plain_text";

    vm.syntaxes = [
        {aceMode: 'text', display: 'Plain text'},
        {aceMode: 'xml', display: 'XML'},
        {aceMode: 'json', display: 'JSON'},
        {aceMode: 'yaml', display: 'YAML'},
        {aceMode: 'html', display: 'HTML'},
        {aceMode: 'css', display: 'CSS'},
        {aceMode: 'markdown', display: 'Markdown'},
        {aceMode: 'dockerfile', display: 'DockerFile'},
        {aceMode: 'powershell', display: 'PowerShell'},
        {aceMode: 'sh', display: 'Bash'},
        {aceMode: 'batchfile', display: 'Batch'},
        {aceMode: 'ini', display: 'INI'},
        {aceMode: 'coffee', display: 'CoffeeScript'},
        {aceMode: 'csharp', display: 'C#'},
        {aceMode: 'ocaml', display: 'F#'},
        {aceMode: 'apache_conf', display: 'Apache Config'}
    ];

    vm.promptEnabled = !!variable.prompt;

    vm.certificatesEmpty = false;

    vm.cancel = $uibModalInstance.close;

    vm.save = function() {
        $uibModalInstance.close(vm.variable);
    };

    vm.variableTypeChanged = function(){
        vm.variable.isSensitive = vm.variable.type === variableTypes.sensitive().name;

        if (!vm.isTextType()) {
            vm.variable.prompt = null;
            vm.promptEnabled = false;
        }
    };

    vm.editorLoaded = function(editor) {
        vm.editor = editor;
        editor.$blockScrolling = Infinity;
        window.rend = editor.renderer;
    };

    vm.getText = function() {
       return vm.editor.getValue();
    };

    $scope.$watch('vm.syntax', function(newSyntax){
       if (newSyntax && vm.editor) {
           vm.editor.getSession().setMode("ace/mode/" + newSyntax);
       }
    });

    vm.isTextType = function() {
        return vm.variable.type === variableTypes.string().name ||
            vm.variable.type === variableTypes.sensitive().name;
    };

    vm.isCertificateType = function() {
        return vm.variable.type === variableTypes.certificate().name;
    };

    vm.togglePrompt = function() {
        if (vm.promptEnabled) {
            vm.variable.prompt = {};
        } else {
            vm.variable.prompt = null;
        }
    };

    vm.certificateSelected = function(certificateId) {
        vm.variable.value = certificateId;
        vm.save();
    };

    vm.gotoCertificates = function() {
        $location.path("/library/certificates");
        vm.cancel();
    };

});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/variables/variable_value_editor_modal.js
// module id = 6658355944680263
// module chunks = 1